import { Injectable } from '@angular/core';

@Injectable()
export class Documento
{
  public id: number = 0;
  public titulo: string = '';
  public descripcion: string = '';
  public autor: string = '';
  public categoria_id: number = -1;
  public estado: boolean = true;

  constructor() 
  { 
  }

  limpiarVariables()
  {
    this.id = 0;
    this.titulo = '';
    this.descripcion = '';
    this.autor = '';
    this.categoria_id = -1;
    this.estado = true;
  }
}
